import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DocumentsListComponent } from './documents-list.component';
import { AddDocumentComponent } from './add-document/add-document.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { DocIconModule } from '../doc-icon/doc-icon.module';
import { CarouselModule} from 'primeng/carousel';
import {RouterModule} from '@angular/router';
import { GridDocumentComponent } from './grid-document/grid-document.component';
import { HighlightModule } from 'src/app/lib/highlight/highlight.module';

@NgModule({
  imports: [
    CommonModule,
    NgbModule,
    FormsModule,
    NgSelectModule,
    DocIconModule,
    RouterModule,
    CarouselModule,
    HighlightModule
  ],
  declarations: [
    DocumentsListComponent,
    AddDocumentComponent,
    GridDocumentComponent
  ],
  exports: [
    DocumentsListComponent,
    GridDocumentComponent
  ]
})
export class DocumentsListModule { }
